/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest =
  {
    ledgerCanisterId: string;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$inboundSchema:
  z.ZodType<
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$Outbound =
  {
    ledger_canister_id: string;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$outboundSchema:
  z.ZodType<
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$Outbound,
    z.ZodTypeDef,
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$ {
  /** @deprecated use `ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$inboundSchema;
  /** @deprecated use `ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$outboundSchema;
  /** @deprecated use `ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$Outbound` instead. */
  export type Outbound =
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$Outbound;
}

export function listTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequestToJSON(
  listTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest:
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest,
): string {
  return JSON.stringify(
    ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$outboundSchema
      .parse(
        listTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest,
      ),
  );
}

export function listTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest' from JSON`,
  );
}
